import {useQueries} from "@tanstack/react-query";
import userService from "../../../services/user-service";
import projectService from "../../../services/project-service";
import softwareAttendanceService from "../../../services/software-attendance-service";
import templatesService from "../../../services/templates-service";
import modulesService from "../../../services/modules-service";

const UseFetchData = (project) => {
    const projectId = project?.value ?? null

    const queries = useQueries({
        queries: [
            {
                queryFn: () => userService.getResponsibles().then(({data}) => data),
                queryKey: ["responsibles"]
            },
            {
                queryKey: ['requesters', {project}],
                queryFn: () => userService.getRequesters(projectId).then(({data}) => data),
                enabled: !!project
            },
            {
                queryFn: () => projectService.options().then(({data}) => data),
                queryKey: ["projects"]
            },
            {
                queryFn: () => modulesService.modulesOptionsIdValue().then(({data}) => data),
                queryKey: ["modules"]
            },
            {
                queryFn: () => templatesService.options().then(({data}) => data),
                queryKey: ["templates"]
            },
            {
                queryKey: ['attendances', {project}],
                queryFn: () => softwareAttendanceService.getLastAttendances(projectId).then(({data}) => data),
                enabled: !!project
            }
        ]
    });

    return {
        responsibles: queries[0].data,
        requesters: queries[1].data,
        projects: queries[2].data,
        modules: queries[3].data,
        templates: queries[4].data,
        attendances: queries[5].data
    }
};

export default UseFetchData;